import { DropdownOption } from '#sign-up/components/shared/base.form.types';
import { PlanType, planTypeToString } from '#sign-up/components/SignUp/types';

export const PLAN_OPTIONS = [
  {
    title: 'Non-Integrated',
    value: planTypeToString(PlanType.Essentials),
  },
  {
    title: 'Integrated',
    value: planTypeToString(PlanType.Integrated),
  },
];

export const MONTHLY_PAPER_CHECK_COUNT_OPTIONS: DropdownOption[] = [
  { Value: '<50', Text: '<50' },
  { Value: '50-100', Text: '50-100' },
  { Value: '100+', Text: '100+' },
];

export const COMPANY_TYPE_OPTIONS = [
  { Value: 'false', Text: 'Private Entity' },
  { Value: 'true', Text: 'Public Entity' },
];

export const YES_NO_OPTIONS = [
  { Value: 'false', Text: 'No' },
  { Value: 'true', Text: 'Yes' },
];
